import type { IconData } from '@stacksjs/iconify-core'

export const dna: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"m19 19l10 10m-3-12l5 5m-14 4l5 5\"/><path d=\"M34 3c-2 7 7 22-1 30c-3.911 3.911-9.495 3.759-15 2.816M3 34c2.526-.722 6.095-.011 10 .816\"/><path d=\"M14 45c2-7-7-22 1-30c3.911-3.911 9.496-3.759 15-2.815M45 14c-2.526.722-6.095.011-10-.816\"/><path stroke-linejoin=\"round\" d=\"m39 8l1 1M8 39l1 1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dna
